import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Code, Star, Mail, BarChart2 } from 'lucide-react';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-6 flex-wrap">
            <h1 className="text-5xl font-bold text-gray-800">
              N1İnovasyon
            </h1>
          </div>
          
          <div className="flex justify-center mb-8">
            <Smartphone className="text-blue-600 w-16 h-16" />
          </div>
          
          <h2 className="text-3xl font-semibold text-gray-700 mb-8">
            Mobile App Development Center
          </h2>

          <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
            <div className="flex items-center justify-center gap-2 mb-6">
              <h3 className="text-2xl font-bold text-gray-800">
                Cari Takip:
              </h3>
              <span className="text-2xl font-bold text-teal-600">
                Müşteri Cari Takip Sistemi
              </span>
            </div>
            <p className="text-gray-600 mb-4">
              Track your customers' receivables and payables easily. Designed for small businesses and professionals.
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link to="/privacy/caritakip" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
              <span className="text-gray-400">•</span>
              <Link to="/terms/caritakip" className="text-blue-600 hover:text-blue-800 font-medium">
                Terms of Use
              </Link>
            </div>
          </div>

          
          <div className="bg-gray-50 p-8 rounded-lg shadow-lg mt-8">
            <div className="flex items-center justify-center gap-2 mb-6">
              <h3 className="text-2xl font-bold text-gray-800">
                FitQueen:
              </h3>
              <span className="text-2xl font-bold text-pink-600">
                Home Workout Women
              </span>
            </div>
            <p className="text-gray-600 mb-4">
              AI-powered home workout app designed for women. Track your exercises with camera-based pose detection and follow structured training programs.
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link to="/privacy/fitqueen" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
              <span className="text-gray-400">•</span>
              <Link to="/terms/fitqueen" className="text-blue-600 hover:text-blue-800 font-medium">
                Terms of Use
              </Link>
            </div>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg shadow-lg mt-8">
            <div className="flex items-center justify-center gap-2 mb-6">
              <h3 className="text-2xl font-bold text-gray-800">
                KolayCRM:
              </h3>
              <span className="text-2xl font-bold text-indigo-600">
                Customer Management for Small Businesses
              </span>
            </div>
            <p className="text-gray-600 mb-4">
              An easy CRM for small businesses to manage customers, products, sales, payments, appointments, and proposals with multi-user team workspaces.
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link to="/privacy/kolaycrm" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
              <span className="text-gray-400">•</span>
              <Link to="/terms/kolaycrm" className="text-blue-600 hover:text-blue-800 font-medium">
                Terms of Use
              </Link>
            </div>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg shadow-lg mt-8">
            <div className="flex items-center justify-center gap-3 mb-6">
              <img
                src="/randevuicon2.png"
                alt="Randevu Defteri"
                className="w-12 h-12 rounded-xl shadow"
              />
              <h3 className="text-2xl font-bold text-gray-800">
                Randevu Defteri:
              </h3>
              <span className="text-2xl font-bold text-rose-600">
                Appointment Book for Businesses
              </span>
            </div>
            <p className="text-gray-600 mb-4">
              Plan, track, and manage customer appointments and history. Built for business owners to organize their daily schedule with ease.
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link to="/privacy/randevu" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
              <span className="text-gray-400">•</span>
              <Link to="/terms/randevu" className="text-blue-600 hover:text-blue-800 font-medium">
                Terms of Use
              </Link>
            </div>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg shadow-lg mt-8">
            <div className="flex items-center justify-center gap-2 mb-6">
              <h3 className="text-2xl font-bold text-gray-800">
                Araç Cüzdanı:
              </h3>
              <span className="text-2xl font-bold text-emerald-600">
                Vehicle Expense Tracker
              </span>
            </div>
            <p className="text-gray-600 mb-4">
              Track your vehicle expenses for free — fuel, maintenance, insurance and more. Keep all your car costs organized in one place.
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link to="/privacy/araccuzdani" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
              <span className="text-gray-400">•</span>
              <Link to="/terms/araccuzdani" className="text-blue-600 hover:text-blue-800 font-medium">
                Terms of Use
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
              <div className="flex items-center justify-center gap-2 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">
                  Taskimo:
                </h3>
                <span className="text-2xl font-bold text-purple-600">
                  Family Tasks
                </span>
              </div>
              <p className="text-gray-600 mb-4">
                Help parents organize daily routines, assign tasks, and motivate children through rewards.
              </p>
              <Link to="/privacy/taskimo" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
              <div className="flex items-center justify-center gap-2 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">
                  BabyNamePro:
                </h3>
                <span className="text-2xl font-bold text-blue-600">
                  Name Generator
                </span>
              </div>
              <p className="text-gray-600 mb-4">
                Find the perfect name for your baby with our comprehensive name database.
              </p>
              <Link to="/privacy/babyname" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
              <div className="flex items-center justify-center gap-2 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">
                  Ball to Cup:
                </h3>
                <span className="text-2xl font-bold text-green-600">
                  Skill Game
                </span>
              </div>
              <p className="text-gray-600 mb-4">
                Test your skills and reflexes in this addictive physics-based game.
              </p>
              <Link to="/privacy/balltocup" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
              <div className="flex items-center justify-center gap-2 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">
                  Car Wash:
                </h3>
                <span className="text-2xl font-bold text-orange-600">
                  Wash Simulator
                </span>
              </div>
              <p className="text-gray-600 mb-4">
                Experience the satisfying world of car washing in this relaxing simulation game.
              </p>
              <Link to="/privacy/carwash" className="text-blue-600 hover:text-blue-800 font-medium">
                Privacy Policy
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
              <Code className="text-blue-600 w-12 h-12 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Modern Technologies
              </h3>
              <p className="text-gray-600">
                Flawless applications with the most up-to-date development tools and frameworks
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
              <Star className="text-blue-600 w-12 h-12 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Superior Quality
              </h3>
              <p className="text-gray-600">
                High-performance mobile solutions compliant with industry standards
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
              <Smartphone className="text-blue-600 w-12 h-12 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Multi-Platform Support
              </h3>
              <p className="text-gray-600">
                Native application development for iOS and Android platforms
              </p>
            </div>
          </div>

          <div className="mt-16 space-y-4">
            <div className="flex items-center justify-center gap-2 text-gray-600">
              <Mail className="w-5 h-5" />
              <span>Support: </span>
              <a href="mailto:hi@n1inovasyon.com" className="text-blue-600 hover:text-blue-800">
                hi@n1inovasyon.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;